<template>
  <div>
    <b-modal
      hide-footer
      hide-backdrop
      no-close-on-esc
      centered
      no-fade
      no-stacking
      title="Hardware Settings"
      ref="posHardwareSettings"
      id="posHardwareSettings"
      size="sm"
    >
    <div class="row settings-box" v-if="DeviceUniqueCode && HARDWARE_SETTING_ON_POS == 'Y'">
      <!-- <div class="col-12 setting-head text-blue border-bottom mb-2 pb-2">
          {{'Hardware Settings'}}
        </div> -->
        <div class="col-12 py-2">
            <div class="row">
              <!-- <div class="col-12 d-flex align-items-center fs-11">Hardware Cinema:</div> -->
              <div class="col-12">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                  <label
                        :class="pos_settings.HardwareSettings.selectedCinema ? 'shift-up': ''"
                        >{{ 'Cinema' }}</label
                      >
                    <multiselect
                      :options="CINEMALIST"
                      v-model="pos_settings.HardwareSettings.selectedCinema"
                      :searchable="true"
                      label="cine_name"
                      track-by="cine_id"
                      placeholder="."
                      @select="onSelectHardwareCinema($event, 'select')"
                      @remove="onSelectHardwareCinema($event, 'remove')"
                    ></multiselect>
                    </div>
                        </div>
              </div>
            </div>
          </div>
        <div class="col-12 py-2">
            <div class="row">
              <!-- <div class="col-12 d-flex align-items-center fs-11">POS Location:</div> -->
              <div class="col-12">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                  <label
                        :class="pos_settings.HardwareSettings.selectedLocation ? 'shift-up': ''"
                        >{{ 'POS Location' }}</label
                      >
                    <multiselect
                      :options="HARDWARE_LOCATIONS"
                      v-model="pos_settings.HardwareSettings.selectedLocation"
                      :searchable="true"
                      label="location_name"
                      track-by="hl_id"
                      placeholder="."
                      @select="onSelectHardwareLocation($event, 'select')"
                      @remove="onSelectHardwareLocation($event, 'remove')"
                    ></multiselect>
                    </div>
                        </div>
              </div>
            </div>
          </div>
    </div>

    <div class="d-flex align-items-center w-100 justify-content-center my-5" v-else>
      <div>Device ID Not Found</div>
    </div>
 
    <div class="row">
      <div class="col-12 pt-3 text-center">
        <button v-on:click="saveSettings()" class="btn-blue">Save</button>
        <button
          @click.prevent.stop="$bvModal.hide('posHardwareSettings')"
          class="btn-blue"
        >
          Cancel
        </button>
      </div>
    </div>

      
    </b-modal>
  </div>
</template>

<script>
import { BASEURL } from "@/config/index.js";
import Nav from "@/Nav";
import MasterService from "@/services/MasterService";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import { backendSocket, EventBus } from "@/main.js";

export default {
  props: {},
  components: {
    Vkeyboard,
    VkeyboardFloat
  },
  data() {
    return {
      pos_settings: {
        HardwareSettings: {
          selectedLocation: "",
          hardware_location_id: null,
          cinema_id: null,
          selectedCinema: ""
        }
      },
      DeviceUniqueCode: null,
      hardware_id: null,
      HardwareLocations: [],
       keyboardsVisible: {
        showFirstNameKeyboard: false,
        showLastNameKeyboard: false,
        showEmailKeyboard: false,
      },
    };
  },
  sockets: {
    hardwareId: function(macId) {
      if (macId) {
        this.hardware_id = macId;
      }
    }
  },
  computed: {
    HARDWARE_SETTING_ON_POS() {
      return this.$store.getters.HARDWARE_SETTING_ON_POS
    },
    HARDWARE_LOCATIONS() {
      return this.$store.getters.HARDWARE_LOCATIONS
    },
    CINEMALIST() {
      return this.$store.getters.ALL_CINEMA_AARAY
    },
    POS_HARDWARE_SETTINGS() {
      return this.$store.getters.POS_HARDWARE_SETTINGS
    }
  },
  beforeMount() {
    this.DeviceUniqueCode = window.localStorage.getItem("deiviceUniqueCode")
      ? window.localStorage.getItem("deiviceUniqueCode")
      : "";
    // if(this.DeviceUniqueCode) {
    //   this.$store.dispatch("fetchPosHardwareSettings", this.DeviceUniqueCode);
    //  }  
  },
  mounted() {
      //  Object.keys(this.pos_settings.HardwareSettings).map((key) => {
      //   this.pos_settings.HardwareSettings[key] = this.POS_HARDWARE_SETTINGS[key] ? this.POS_HARDWARE_SETTINGS[key] : '';
      // })  
      setTimeout(() => {
        this.pos_settings.HardwareSettings['selectedLocation'] = this.POS_HARDWARE_SETTINGS['selectedLocation']
        this.pos_settings.HardwareSettings['hardware_location_id'] = this.POS_HARDWARE_SETTINGS['hardware_location_id']
        this.pos_settings.HardwareSettings['cinema_id'] = this.POS_HARDWARE_SETTINGS['cinema_id']
        this.pos_settings.HardwareSettings['selectedCinema'] = this.POS_HARDWARE_SETTINGS['selectedCinema']
      }, 500);

  },
  methods: {
     onSelectHardwareLocation(event, type = 'select') {
      if(type == 'select') {
        this.pos_settings.HardwareSettings.selectedLocation = event;
        this.pos_settings.HardwareSettings.hardware_location_id = event.hl_id;
      } else if(type == 'remove') {
        this.pos_settings.HardwareSettings.selectedLocation = '';
        this.pos_settings.HardwareSettings.hardware_location_id = null;
      }
    },
    onSelectHardwareCinema(event, type = 'select') {
      if(type == 'select') {
        this.pos_settings.HardwareSettings.selectedCinema = event;
        this.pos_settings.HardwareSettings.cinema_id = event.cine_id;
        this.$store.dispatch("fetchHardwareLocations", {cinema_id: event.cine_id})
      } else if(type == 'remove') {
        this.pos_settings.HardwareSettings.selectedCinema = '';
        this.pos_settings.HardwareSettings.cinema_id = null;
        this.$store.dispatch("fetchHardwareLocations", {cinema_id: null})
      }
    },
    saveSettings() {
      let loader = this.$loading.show();
      let hardwareObj = {
        hardware_location_id: this.pos_settings.HardwareSettings.hardware_location_id,
        cinema_id: this.pos_settings.HardwareSettings.cinema_id,
        unique_id: this.DeviceUniqueCode
      }
      MasterService.UpdatePosHardwareSettings(hardwareObj).then((response) => {
        const {data} = response;
        console.log('DATA', data);
        if(data && data.status) {
          if(this.DeviceUniqueCode){
            this.$store.dispatch("fetchPosHardwareSettings", this.DeviceUniqueCode);
          }
          console.log('SUCCESSFULLY SAVED HARDWARE LOCATION');
        } else {
          console.log('UNABLE TO SAVE HARDWARE LOCATION');
        }
      }).catch((err) => {
        console.log('Error:', err);
      }).finally(() => {
        this.$bvModal.hide('posHardwareSettings')
        loader.hide();
      })
    },
  },
};
</script>
<style>
.disbled-section {
  cursor: not-allowed;
  opacity: 0.4;
}

.settings-box {
  font-size: 12px;
  font-weight: bold;
}
#posHardwareSettings___BV_modal_content_ {
  width: 135% !important;
  max-width: 135% !important;
  min-width: 135% !important;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/PosHardwareSettingsPopup.vue